import axiosInstance from './axiosInstance';

export const createOrder = async (orderData) => {
  try {
    // Ensure the order data matches the API specification
    const payload = {
      orderItems: orderData.orderItems.map(item => ({
        productId: item.productId,
        quantity: item.quantity,
        price: item.price
      })),
      totalAmount: orderData.totalAmount,
      paymentMethod: orderData.paymentMethod,
      customerName: orderData.customerName,
      customerEmail: orderData.shippingAddress.customerEmail,
      shippingAddress: {
        customerName: orderData.shippingAddress.customerName,
        street: orderData.shippingAddress.street,
        city: orderData.shippingAddress.city,
        state: orderData.shippingAddress.state,
        postalCode: orderData.shippingAddress.postalCode,
        country: orderData.shippingAddress.country,
      },
      isPreorder: orderData.isPreorder || false,
    };

    const response = await axiosInstance.post('/orders', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};